import {createAsyncThunk} from '@reduxjs/toolkit';
import {integrationsApi} from 'api';
import {IUpdateGoogleClassroomIntegrationPayload} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {integrationDetailsMessages} from '../../details/utils/constants';
import {prefix} from './config';

interface IUpdateGoogleClassroom {
  integrationId: string;
  payload: IUpdateGoogleClassroomIntegrationPayload;
}

export const updateGoogleClassroomIntegrationThunk: any = createAsyncThunk(
  `${prefix} updateMicrosoftTeamsIntegration`,
  async ({integrationId, payload}: IUpdateGoogleClassroom, {dispatch, rejectWithValue}) => {
    try {
      const {data} = await integrationsApi.updateGoogleClassroomIntegration(integrationId, payload);
      dispatch(toastNotificationManager.createSuccessToastAction(integrationDetailsMessages.updateIntegrationSuccess));
      return data;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.response.data.messages[0] ?? integrationDetailsMessages.unknownIntegrationError
        )
      );
      return rejectWithValue({error});
    }
  }
);
